import { bufferToHexCodes } from 'pvutils'
import RSAPublicKey from '@/utils/rsa-pubkey'
const asn1js = require('asn1js')
// const pkijs = require('pkijs')

function _getCertName ({ cert }) {
  const CN = '2.5.4.3'
  for (const typeAndValue of cert.subject.typesAndValues) {
    if (typeAndValue.type === CN) {
      return typeAndValue.value.valueBlock.value
    }
  }
}

function _getCertInfoByMap ({ map, source }) {
  const result = {}

  for (const typeAndValue of source) {
    // console.log(typeAndValue)
    let type = map[typeAndValue.type]
    if (typeof type === 'undefined') type = typeAndValue.type

    const val = typeAndValue.value.valueBlock.value

    result[type] = val

    // const obj = {
    //   name: type,
    //   value: val
    // }

    // result.push(obj)
  }

  return result
}

function _getCertSubjectName ({ cert }) {
  const map = {
    '2.5.4.6': 'country',
    '2.5.4.10': 'organization',
    '2.5.4.11': 'organizationUnit',
    '2.5.4.3': 'commonName'
  }
  return _getCertInfoByMap({
    map,
    source: cert.subject.typesAndValues
  })
}

function _getCertIssuerName ({ cert }) {
  const map = {
    '2.5.4.6': 'country',
    '2.5.4.10': 'organization',
    '2.5.4.11': 'organizationUnit',
    '2.5.4.3': 'commonName'
  }

  return _getCertInfoByMap({ map, source: cert.issuer.typesAndValues })
}

function _getCertPublicKeySize ({ cert }) {
  let publicKeySize = '< unknown >'

  if (
    cert.subjectPublicKeyInfo.algorithm.algorithmId.indexOf(
      '1.2.840.113549'
    ) !== -1
  ) {
    const asn1PublicKey = asn1js.fromBER(
      cert.subjectPublicKeyInfo.subjectPublicKey.valueBlock.valueHex
    )
    const rsaPublicKey = new RSAPublicKey({ schema: asn1PublicKey.result })

    const modulusView = new Uint8Array(rsaPublicKey.modulus.valueBlock.valueHex)
    let modulusBitLength = 0

    if (modulusView[0] === 0x00) {
      modulusBitLength = (rsaPublicKey.modulus.valueBlock.valueHex.byteLength - 1) * 8
    } else {
      modulusBitLength = rsaPublicKey.modulus.valueBlock.valueHex.byteLength * 8
    }

    publicKeySize = modulusBitLength.toString()
  }

  return publicKeySize
}

function _getCertPublicKey ({ cert }) {
  const size = _getCertPublicKeySize({ cert })
  return [
    {
      name: 'size',
      value: size
    }
  ]
}

function _getCertNotAfter ({ cert }) {
  return cert.notAfter.value
}

function _getCertNotBefore ({ cert }) {
  return cert.notBefore.value
}

function _getCertSerialNumber ({ cert }) {
  return bufferToHexCodes(cert.serialNumber.valueBlock.valueHex)
}

function _getCertSignatureAlgorithm ({ cert }) {
  const algomap = {
    '1.2.840.113549.1.1.2': 'MD2 with RSA',
    '1.2.840.113549.1.1.4': 'MD5 with RSA',
    '1.2.840.10040.4.3': 'SHA1 with DSA',
    '1.2.840.10045.4.1': 'SHA1 with ECDSA',
    '1.2.840.10045.4.3.2': 'SHA256 with ECDSA',
    '1.2.840.10045.4.3.3': 'SHA384 with ECDSA',
    '1.2.840.10045.4.3.4': 'SHA512 with ECDSA',
    '1.2.840.113549.1.1.10': 'RSA-PSS',
    '1.2.840.113549.1.1.5': 'SHA1 with RSA',
    '1.2.840.113549.1.1.14': 'SHA224 with RSA',
    '1.2.840.113549.1.1.11': 'SHA256 with RSA',
    '1.2.840.113549.1.1.12': 'SHA384 with RSA',
    '1.2.840.113549.1.1.13': 'SHA512 with RSA'
  } // array mapping of common algorithm OIDs and corresponding types

  let signatureAlgorithm = algomap[cert.signatureAlgorithm.algorithmId]

  if (typeof signatureAlgorithm === 'undefined') {
    signatureAlgorithm = cert.signatureAlgorithm.algorithmId
  } else {
    signatureAlgorithm = `${signatureAlgorithm} (${
      cert.signatureAlgorithm.algorithmId
    })`
  }

  return signatureAlgorithm
}

function _getCertExtensions ({ cert }) {
  const result = []

  if ('extensions' in cert) {
    for (let i = 0; i < cert.extensions.length; i++) {
      result.push(cert.extensions[i].extnID)
    }
  }

  return result
}

export function parseCertificate ({ cert }) {
  const name = _getCertName({ cert })
  const subjectName = _getCertSubjectName({ cert })
  const issuerName = _getCertIssuerName({ cert })
  const publicKey = _getCertPublicKey({ cert })
  const serialNumber = _getCertSerialNumber({ cert })
  const notAfter = _getCertNotAfter({ cert })
  const notBefore = _getCertNotBefore({ cert })
  const signatureAlgorithm = _getCertSignatureAlgorithm({ cert })
  const extensions = _getCertExtensions({ cert })

  const obj = {
    name,
    subjectName,
    issuerName,
    publicKey,
    serialNumber,
    notAfter,
    notBefore,
    signatureAlgorithm,
    extensions
  }

  return obj
}

export default {
  parseCertificate
}
